<template>
<div class="index" v-loading="$root.loading" :element-loading-text="$root.loadingText" element-loading-spinner="el-icon-loading" element-loading-background="#000000a3">
    <headlogo />
    <router-view />
    <footer-bottom />
    <newUser />
</div>
</template>

<script>
import header from '@/components/header'
import footer from '@/components/footer'
import newUser from '@/components/newUserPop.vue' // 是否是新用户
export default {
  components: {
    headlogo: header,
    footerBottom: footer,
    newUser: newUser
  },
  data: function () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue